export default "__VITE_ASSET__ByGfcTw7__"